// jQuery comes from the single copy loaded in layout/theme.liquid (3.7.1), which runs before this deferred file.

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
  	if(days == null)
      days = 2;
  
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function coldPackCookieName(prefix) {
  var token = encodeURIComponent(String(Rebuy.Cart.cart.token)).replace(/[!'()*]/g, function(character) {
    return '%' + character.charCodeAt(0).toString(16).toUpperCase();
  });
  return 'netrition_cp_v2_' + prefix + '_' + token;
}
function getColdPackCookie(prefix) {
  var cookiePairs = document.cookie.split(';');
  function readExact(name) {
    if(!/^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/.test(name)) return null;
    for(var index = 0; index < cookiePairs.length; index++) {
      var pair = cookiePairs[index];
      var separator = pair.indexOf('=');
      if(separator !== -1 && pair.slice(0, separator).trim() === name) return pair.slice(separator + 1);
    }
    return null;
  }
  var value = readExact(coldPackCookieName(prefix));
  if(value !== null) return value;
  return readExact(prefix + String(Rebuy.Cart.cart.token));
}
function setColdPackCookie(prefix, value, days) {
  setCookie(coldPackCookieName(prefix), value, days);
}

function isWholesaleCustomer(){
	return (window.shopifyCustomer != null && window.shopifyCustomer.includes("Netrition_WholesaleY"));
}
function updateRebuySubTotalSavingText(savingmoneytext){
  if (savingmoneytext != null) {
	document.querySelector(".rebuy-cart__flyout-subtotal-label span").innerHTML = "Subtotal <span class='cc_savings'>(You save <span class='money'>"+ savingmoneytext + "</span>)</span>";
  } else {
  	document.querySelector(".rebuy-cart__flyout-subtotal-label span").innerHTML = "Subtotal";
  }
}
function rechargeWidgetCallback()
{
	if(document.querySelector(".rc-subscription-details .rc-subscription-details__button span") != null){

        console.log("New widget");
		//document.querySelector(".rc-subscription-details .rc-subscription-details__button span").innerText="";
        //document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa");
        //document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa-question-circle");

      	var rstate = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state;
    	var currentSelectedVariant = rstate.variant;
      	if(rstate.sellingPlan != undefined){
      		// first time load
          	var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = rstate.variant;
            var curVariant = allVariants.find(s=>s.external_variant_id == currentSelectedVariant);
            	var disct = 0;
                if(parseFloat(curVariant.prices[0].compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices[0].compare_at_price) - parseFloat(curVariant.prices[0].unit_price);
                    document.querySelectorAll(".product-meta__label-list span.product-label.product-label--on-sale").forEach(el => el.innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>');
                }

                // display subscription price = curVariant.prices.discounted_price
                document.querySelectorAll(".current_price").forEach(el => el.innerText = Shopify.formatMoney((parseFloat(curVariant.prices[0].unit_price) * 100), Shopify.money_format));

      	}
      
      	var radios = document.querySelectorAll('.rc-widget [type=radio][name=purchaseOption]');
        radios.forEach(radio => radio.addEventListener('change', () => 
        {
            var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state.variant
            var curVariant = allVariants.find(s=>s.external_variant_id == currentSelectedVariant);
            
            if(radio.value=="onetime")
            {
                var disct = 0;
                if(parseFloat(curVariant.prices[0].compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices[0].compare_at_price) - parseFloat(curVariant.prices[0].unit_price);
                    document.querySelectorAll(".product-meta__label-list span.product-label.product-label--on-sale").forEach(el => el.innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>');
                }
                // display price = curVariant.prices.unit_price
                document.querySelectorAll(".current_price").forEach(el => el.innerText = Shopify.formatMoney((parseFloat(curVariant.prices[0].unit_price) * 100), Shopify.money_format));
            }else{
                var disct = 0;
                if(parseFloat(curVariant.prices[0].compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices[0].compare_at_price) - parseFloat(curVariant.prices[0].unit_price);
                    document.querySelectorAll(".product-meta__label-list span.product-label.product-label--on-sale").forEach(el => el.innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), Shopify.money_format) + '</span>');
                }

                // display subscription price = curVariant.prices.unit_price
 document.querySelectorAll(".current_price").forEach(el => el.innerText = Shopify.formatMoney((parseFloat(curVariant.prices[0].unit_price) * 100), Shopify.money_format));
            }

        }));
    }
}

function extractRcPriceText(el) {
    if (!el) return null;
    var matches = (el.textContent || '').match(/[€£$]\s?[\d,]+\.?\d*|[\d,]+\.?\d*\s?[€£$]/g);
    return matches && matches.length ? matches[matches.length - 1].trim() : (el.textContent || '').trim();
}

function syncMainPriceWithSubscriptionWidgetV2(host) {
    var root = host.shadowRoot;
    if (!root) return false;

    var checkedRadio = root.querySelector('input[name="purchaseOption"]:checked');
    if (!checkedRadio) return false;

    var isSubscription = checkedRadio.value === 'subscription';
    var priceEl = isSubscription
        ? root.querySelector('[part="rc-purchase-option__discounted-price"]')
        : root.querySelector('[part="rc-purchase-option__price"]');
    var priceText = extractRcPriceText(priceEl);
    if (!priceText) return false;

    document.querySelectorAll('.current_price').forEach(function(el){ el.innerText = priceText; });

    if (isSubscription) {
        var originalEl = root.querySelector('[part="rc-purchase-option__original-price"]');
        var originalPrice = parseFloat((extractRcPriceText(originalEl) || '').replace(/[^\d.]/g, ''));
        var discountedPrice = parseFloat(priceText.replace(/[^\d.]/g, ''));

        if (originalEl && originalPrice > discountedPrice) {
            var savings = originalPrice - discountedPrice;
            document.querySelectorAll(".product-meta__label-list span.product-label.product-label--on-sale").forEach(function(el){
                el.innerHTML = 'Save <span>' + Shopify.formatMoney((savings * 100), Shopify.money_format) + '</span>';
            });
        }

    }

    return true;
}

function attachSubscriptionWidgetV2PriceSync(host) {
    if (!host.shadowRoot) {
        if (window.customElements && typeof customElements.whenDefined === 'function') {
            customElements.whenDefined(host.tagName.toLowerCase()).then(function(){
                attachSubscriptionWidgetV2PriceSync(host);
            });
        } else {
            setTimeout(function(){ attachSubscriptionWidgetV2PriceSync(host); }, 200);
        }
        return;
    }

    syncMainPriceWithSubscriptionWidgetV2(host);

    if (window.MutationObserver && !host.__priceSyncObserverAttached) {
        host.__priceSyncObserverAttached = true;
        var observer = new MutationObserver(function(){ syncMainPriceWithSubscriptionWidgetV2(host); });
        observer.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });

        document.addEventListener('change', function(e){
            var target = e.composedPath()[0];
            if (target && target.tagName === 'INPUT' && target.name === 'purchaseOption') {
                syncMainPriceWithSubscriptionWidgetV2(host);
            }
        }, true);
        document.addEventListener('input', function(e){
            var target = e.composedPath()[0];
            if (target && target.tagName === 'INPUT' && target.name === 'purchaseOption') {
                syncMainPriceWithSubscriptionWidgetV2(host);
            }
        }, true);

    }
}

function initSubscriptionWidgetV2PriceSync() {
    if (window.__subscriptionWidgetV2PriceSyncInitialized) return;
    window.__subscriptionWidgetV2PriceSyncInitialized = true;

    var host = document.querySelector('recharge-subscription-widget');
    if (host) {
        attachSubscriptionWidgetV2PriceSync(host);
        return;
    }

    if (!window.MutationObserver) return;

    var widgetWatcher = new MutationObserver(function(){
        var host = document.querySelector('recharge-subscription-widget');
        if (host) {
            widgetWatcher.disconnect();
            attachSubscriptionWidgetV2PriceSync(host);
        }
    });
    widgetWatcher.observe(document.body, { childList: true, subtree: true });
}

(function(){

  setTimeout(function(){
    if(typeof yotpo == "object"){
    	//yotpo.refreshWidgets();
      	//yotpo.initWidgets();
    }
    // fix for Activate Customer popup
    if(document.querySelector("div#AAI-buttontext a") != null)
    	document.querySelector("div#AAI-buttontext a").attributes.href.value = "javascript:void(0)"
    if(document.querySelector("#AAI-cancel a") != null)
    	document.querySelector("#AAI-cancel a").attributes.href.value = "javascript:void(0)"
    
  },2000);
  
  	if(isWholesaleCustomer())
  	{
      	document.body.classList.add('norebuycart');
      	document.body.classList.remove('nominicart');
    }
  
  
  if(theme.pageType == 'product') {
  	setTimeout(rechargeWidgetCallback,2000);
    setTimeout(rechargeWidgetCallback,3000);
    initSubscriptionWidgetV2PriceSync();

    scrollToReviews();

    // for product page thumbnail image not display when variant selected.    
    document.querySelectorAll(".product-gallery__carousel-item.is-selected").forEach(function(item){ if(item.classList.contains("is-filtered") == false) {  document.querySelector(".product-gallery__thumbnail-list a.product-gallery__thumbnail[data-media-id='"+ item.attributes["data-media-id"].value +"']").click() }; });
    
  }
  
  
})();

function scrollToReviews(){
  // Product page: if URL contains reviews=y, scroll to Yotpo reviews
  try {
    var params = new URLSearchParams(window.location.search || "");
    if (params.get('reviews') === 'y') {
      var tries = 0;
      var maxTries = 60; // ~9s at 150ms intervals
      var observerInitialized = false;
      var widgetObserver = null;
      var intervalId = setInterval(function(){
        var t1 = document.querySelector('[data-yotpo-prevent-load-rs]');
        var t2 = document.querySelector('.yotpo.yotpo-main-widget');
        var t3 = document.querySelector('#product-reviews');
        var target = t1 || t2 || t3;
        if (target) {
          // If using the Yotpo container that defers load, watch for the main widget to appear
          if (t1) {
            var widgetEl = t1.querySelector('#yotpo-reviews-main-widget');
            if (!widgetEl) {
              if (!observerInitialized) {
                try {
                  widgetObserver = new MutationObserver(function(mutations){
                    for (var i = 0; i < mutations.length; i++) {
                      if (t1.querySelector('#yotpo-reviews-main-widget')) {
                        try { widgetObserver.disconnect(); } catch(e) {}
                        clearInterval(intervalId);
                        setTimeout(function(){
                          var scrollTarget = t1.querySelector('#yotpo-reviews-main-widget') ||
                                             document.querySelector('.yotpo-widget-instance') ||
                                             document.querySelector('.yotpo.yotpo-main-widget') ||
                                             document.querySelector('#product-reviews');
                                                     if (scrollTarget) {
                             var top2 = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 150;
                             window.scroll({ top: top2, left: 0, behavior: 'smooth' });
                           }
                        }, 2000);
                        return;
                      }
                    }
                  });
                  widgetObserver.observe(t1, { childList: true, subtree: true });
                  observerInitialized = true;
                } catch(obsErr) {
                }
              }
              tries++;
              return; // keep polling until widget appears
            }
            // Widget already present under t1; delay and scroll
            clearInterval(intervalId);
            try { if (widgetObserver) widgetObserver.disconnect(); } catch(e) {}
                         setTimeout(function(){
               var top3 = widgetEl.getBoundingClientRect().top + window.pageYOffset - 150;
               window.scroll({ top: top3, left: 0, behavior: 'smooth' });
             }, 2000);
            return;
          }
                     // No deferring container: scroll to available target immediately
           clearInterval(intervalId);
           var top = target.getBoundingClientRect().top + window.pageYOffset - 150;
           window.scroll({ top: top, left: 0, behavior: 'smooth' });
        } else if (++tries >= maxTries) {
          clearInterval(intervalId);
        }
      }, 150);
    }
  } catch(e) {}
}

function removeSmartCartForWholeSale(){
	if(isWholesaleCustomer())
  	{
      	document.body.classList.add('norebuycart');
      	document.body.classList.remove('nominicart');
  		// disbale the Rebuy SMARTCART	
    	window.Rebuy.SmartCart.destroy();
    	window.Rebuy.SmartCart.unbindEvents();
    
  	}
}
function rebuySmartCartAfterChangeUpdates(cartData){  

  document.querySelectorAll(".rebuy-cart__flyout-items .store-recharge-product").forEach(s=> s.remove());
  if(window.Rebuy.SmartCart.cart != null){
    		var total_savings = 0;
            var discounted_price_total = 0;
        		
    		window.Rebuy.SmartCart.cart.items.filter(function(citm, index){
              
              if(JSON.parse(localStorage.getItem("v" + citm.variant_id)) == null){

                /*await fetch("/products/" + citm.handle + ".js").then(s=>s.json()).then(data=> {                    
                        var variant_id = citm.variant_id;
                                          var variant = $.grep(data.variants, function(v) {
                                            return v.id == variant_id;
                                          });
                    
                                          localStorage.setItem("v"+variant_id, JSON.stringify({ compare_at_price : variant[0].compare_at_price }));
                                          if(variant[0] && variant[0].compare_at_price > citm.price) {                        
                                            discounted_price_total += citm.price * citm.quantity;
                                            total_savings += variant[0].compare_at_price * citm.quantity;
                                          }
                        
                    });*/
                
              	$.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + citm.handle + ".js",
                    success: function(data) {
                      var variant_id = citm.variant_id;
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == variant_id;
                      });

                      localStorage.setItem("v"+variant_id, JSON.stringify({ compare_at_price : variant[0].compare_at_price }));
                      if(variant[0] && variant[0].compare_at_price > citm.price) {                        
                        discounted_price_total += citm.price * citm.quantity;
                        total_savings += variant[0].compare_at_price * citm.quantity;
                      }
                    }
                  });
                
                }else{
                  // found in localstorage. 
                  var vitemzero = JSON.parse(localStorage.getItem("v" + citm.variant_id));
                  if(vitemzero && vitemzero.compare_at_price > citm.price) {                        
                      discounted_price_total += citm.price * citm.quantity;
                      total_savings += vitemzero.compare_at_price * citm.quantity;
                  }                
              	}


              
             // EACH ITEM WISE SMARTCART. LET TAKE ITS SELLING PLAN AND DISPLAY IF EXISTS
              // rebuy-cart__flyout-item-variant-title 
              var subtitleid = "sub" + citm.key.replace(":","");
              // REMOVE ALL ELEMENTS OF MATCHED ID. AS THERE MAY BE OLD UI BEFORE NEW UPDATES. 
              //document.querySelectorAll(".rebuy-cart__flyout-items .store-recharge-product").forEach(s=> s.remove());
              
              if(citm.selling_plan_allocation != null){
                if(citm.selling_plan_allocation.selling_plan != null){
                  const newEl = document.createElement("div");
                  newEl.id = subtitleid;
                  newEl.classList.add("rebuy-cart__flyout-item-variant-subtitle");
                  newEl.classList.add("store-recharge-product");
                  
                  newEl.innerText = citm.selling_plan_allocation.selling_plan.name;

                  var vtitleElem = document.querySelectorAll(".rebuy-cart__flyout-items .rebuy-cart__flyout-item")[index];
                  // V2 owns its cadence label and may not render the legacy row wrapper.
                  if(vtitleElem && !vtitleElem.querySelector(".netrition-cart-selling-plan") && vtitleElem.querySelector("#" + newEl.id) == null){
                    var vtitle = vtitleElem.querySelector(".rebuy-cart__flyout-item-variant-title");
                    if(vtitle) vtitle.after(newEl);
                  }                  
                }
              }
              
                
            });
    
    	if (total_savings > 0) {              
        	updateRebuySubTotalSavingText(Shopify.formatMoney(total_savings - discounted_price_total, Shopify.money_format));
        } else {              
        	updateRebuySubTotalSavingText(null);
        }      
  }
  
}

function minOrderUIButton(carttotal){
  // Hide checkout button.
          if(document.querySelector(".rebuy-cart__flyout-actions") != null){
            
            if(parseFloat(document.body.attributes.minorder.value) > (carttotal/100)){
              document.querySelector(".rebuy-cart__flyout-actions").classList.add("minorderrequired");
              
              if(document.querySelector(".rebuy-cart__flyout-integration div.minordernotice") != null)
                  document.querySelector(".rebuy-cart__flyout-integration div.minordernotice").style.display = "block";
              
              updateCheckoutBtnProgressBar((carttotal/100),parseFloat(document.body.attributes.minorder.value));
              
            }else{
              
              document.querySelector(".rebuy-cart__flyout-actions").classList.remove("minorderrequired");
              if(document.querySelector(".rebuy-cart__flyout-integration div.minordernotice") != null)
                  document.querySelector(".rebuy-cart__flyout-integration div.minordernotice").style.display = "none";
            }
          }
}

document.addEventListener('rebuy.init', function(event){
  	console.log('rebuy.init event', event.detail);  	

    // Call cold pack provinces
    checkColdPackStates();

});

document.addEventListener('rebuy:smartcart.ready', function(event){ 

  console.log('rebuy:smartcart.ready event', event.detail, event.detail.smartcart.cart.total_price);
  //removeSmartCartForWholeSale();  
  if(window.theme.offer_freeabove == true){
    addGiftButton('Select Your Cyber Monday Gift !');
    //manageCartFreeGiftActionButton(event);
  }
  else if(window.theme.offer_freeaboveGifts == true){
    addGiftButton('Select Your Free Gift');
    //manageCartFreeGiftActionButton(event);
    afterRebuyInitCheckup();
  }
  
  minOrderUIButton(event.detail.smartcart.cart.total_price);
  setTimeout(function(){ removeSmartCartForWholeSale();  },2000); 

  addCheckoutProgressButton();
  
});
document.addEventListener('rebuy:smartcart.show', function(event){ 

  if(typeof __attentive == "object"){
      __attentive.hide()
  }
  
  if(typeof closeGiftCart == "function")
    closeGiftCart();

  rebuyButtonUpdateFreeItem();
  
}); 
document.addEventListener('rebuy:smartcart.hide', (event) => {
  
    document.body.classList.remove('modal-open-cart');

    if(typeof __attentive == "object"){
      __attentive.show();
    }
    
});

document.addEventListener('theme:quickview:opened', function(event){ 
  if(typeof yotpo != "undefined")
  {
  	yotpo.initWidgets();
  }
}); 


document.addEventListener('theme:sliderpopup:opened', function(event){ 
  console.log('theme:sliderpopup:opened', event.detail); 
  
  if(typeof __attentive == "object"){
  	__attentive.hide();
  }
  
}); 
document.addEventListener('theme:sliderpopup:closed', function(event){ 
  console.log('theme:sliderpopup:closed', event.detail); 
  
  if(typeof __attentive == "object"){
  	__attentive.show();
  }
  
}); 

document.addEventListener('rebuy:cart.change', function(event){
    	setTimeout(function(){
    	
          if(document.querySelectorAll(".rebuy-cart__flyout-integration div.minordernotice").length > 1){
            	document.querySelectorAll(".rebuy-cart__flyout-integration div.minordernotice").forEach(function(itm, index){ if(index > 0){ itm.remove();  } });
          }
          
          // Hide checkout button.
          if(document.querySelector(".rebuy-cart__flyout-actions") != null && Rebuy.SmartCart.cart != null){
              minOrderUIButton(Rebuy.SmartCart.cart.total_price);
          }
          
          if(window.Rebuy.SmartCart != null && window.Rebuy.SmartCart.cart != null){
          	// UPDATE THEME'S CART ITEM COUNT
    		document.querySelector(".header__cart-count").innerText = window.Rebuy.SmartCart.cart.item_count;
          }
          
          if(isWholesaleCustomer() == false){
          	if(window.theme.cartattributeupdate != true){
                //console.log("is wholesale customer heatsnsitive fired");
            	heatSensitiveService();
            }else{
              window.theme.cartattributeupdate = false;
            }
          }
          
          rebuySmartCartAfterChangeUpdates(event);
          
          	if (typeof window.bppayLaterFunction.refreshCartHtmls == "function")
            {
              window.bppayLaterFunction.refreshCartHtmls();
            }
          
            
            if(document.querySelector(".myrebuy-freegiftaction") != null){
              manageCartFreeGiftActionButton(event.detail.cart.cart);
            }

            if(window.theme.offer_free_item_offer_enable){
            // Vendor based free item Syntrax code
              const items = window.Rebuy.Cart.getItems();
              const vendor = window.theme.offer_free_item_eligible_vendor;
              const totalvenitems = items
              .filter(item => item.vendor.toLowerCase() === vendor && item.variant_id != window.theme.offer_free_item_variant_id)
              .map(item => item.final_line_price)
              .reduce((acc, price) => acc + price, 0);
              
              if((totalvenitems/100) >= parseFloat(window.theme.offer_free_item_eligible_totalamt)){
                  // check exists or not, else add.
                  var freeexists = items.find(item => item.vendor.toLowerCase() === vendor && item.variant_id == window.theme.offer_free_item_variant_id);
                  if(freeexists == null){
                    // not found but.. should be there. Add it. 
                      	var onedata = { "quantity": 1, "id": window.theme.offer_free_item_variant_id };
                        
                          fetch(window.routes.cartAddUrl + '.js', {
                            body: JSON.stringify(onedata),
                            credentials: 'same-origin',
                            headers: {
                              'Content-Type': 'application/json',
                              'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                            },
                            method: 'POST'
                          }).then(function(response) {
                            return response.json();
                          }).then(function(json) {
                            /* we have JSON */
                            console.log(json);
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                  bubbles: true
                                }));
                          }).catch(function(err) {
                            /* uh oh, we have error. */
                            console.error(err)
                          });
                  }
              }
              
          }

          rebuyButtonUpdateFreeItem();
          
        },300);


});


document.addEventListener("variant:changed", function(e){
    if(e.detail == null || e.detail.variant == null){
      console.log("variant:changed fired in customjs", "DETAIL OBJ NULL");  
      setTimeout(function(){ document.querySelector("form a.klaviyo-bis-trigger").style.display = "none"; },100); 
    }
    // for quick view - out of stock notify form's visibility.  	
    if(e.detail.variant != null &&  e.detail.variant.available)
        $(".modal__dialog .product-form__payment-container div.notify_form").hide();
    else if(e.detail.variant != null)
        $(".modal__dialog .product-form__payment-container div.notify_form").show();

    // To display variant name along with Product name on PDP
    if(e.detail != null && e.detail.variant != null && document.querySelector(".product-form #ptitlevariantname") != null)
      document.querySelector(".product-form #ptitlevariantname").innerText = " - " + e.detail.variant.title;
    
});

document.addEventListener("mobile:menu:opened", function(e){
     // hide Tawk chat plugin
  	if(typeof Tawk_API == "object")
  		Tawk_API.hideWidget();
});

document.addEventListener("mobile:menu:closed", function(e){
     // show Tawk chat plugin
  if(typeof Tawk_API == "object")
  		Tawk_API.showWidget();
});

function rebuyButtonUpdateFreeItem(){
  // TO HIDE FREE ITEM SUBSCRIPTIONS BUTTON IN REBUY CART DRAWER.
            document.querySelectorAll('.rebuy-cart__flyout-items .rebuy-cart__flyout-item-discount-message').forEach(function(discountMessage) {
                if (discountMessage.textContent.trim() === "Free Gift by Netrition") {
                    const liParent = discountMessage.closest('li.rebuy-cart__flyout-item');
                    if (liParent) {
                        const subscriptionElement = liParent.querySelector('.rebuy-cart__flyout-item-subscription');
                        if (subscriptionElement) {
                            subscriptionElement.remove();
                        }
                    }
                }
            });
  
}
function addCheckoutProgressButton(){
  var btncprogress = `<div class="cbprogress-btn" data-progress-style="fill-back"><div class="btn">Add $<span class="amtRemaining">20</span> to enable Checkout</div><div class="progress"></div></div>`;
  var element = document.querySelector(".rebuy-cart__flyout-actions");
  
  // Check if the target element exists before injecting HTML
  if (element) {
    // Create a temporary container element
    var tempContainer = document.createElement('div');
  
    // Set the HTML content of the container to your string
    tempContainer.innerHTML = btncprogress;
    tempContainer.style.width="100%";
    // Insert the content as the first child of the target element
    element.insertBefore(tempContainer.firstChild, element.firstChild);
  } else {
    console.error('Target element not found.');
  }

}

function updateCheckoutBtnProgressBar(cartTotal, minOrder) {
  let progressIncrement = 100 / minOrder;
  const progressOverlay = document.querySelector(".cbprogress-btn .progress");
  if(progressOverlay != null){
    const progressText = document.querySelector(".cbprogress-btn .amtRemaining");
    // Calculate the new width based on the increment
    let newWidth = parseFloat(minOrder - cartTotal) || 0;
    newWidth = Math.min(100 - (newWidth * progressIncrement), 100);
  
    // Update the progress bar width
    progressOverlay.style.width = `${newWidth}%`;
    progressText.innerText = parseFloat(minOrder - cartTotal).toFixed(2);
  }
}

async function ipLocationCall(){
    // Used to call internal ip geo location detection service.
    var cntObj = {};
    if(localStorage.getItem("ciplookup") != null){
  		cntObj = JSON.parse(localStorage.getItem("ciplookup"));
    }else{    
      await fetch("https://appbundle.bariatricpal.com/Home/iplookupmain").then(s=>s.json()).then(s=> { cntObj = s });
      localStorage.setItem("ciplookup", JSON.stringify(cntObj));
    }
    
    return { country_code : cntObj.countryCode, province_code :  cntObj.region }
}

async function checkColdPackStates()
  {
    console.log('before start');

        // Set local variable for state allowed for ColdPack service.
      var geoLoc  =  await Rebuy.getGeolocation()
      
      if(geoLoc.province_code == null){
        geoLoc = await ipLocationCall();        
      }
    
      if((geoLoc.country_code == "US" && (window.theme.cart_cold_allowedstateabb.includes(geoLoc.province_code)))  || 
         (geoLoc.country_code != "US" && window.theme.cart_cold_allowedstateabb.includes('XX'))  || (geoLoc.province_code == null) )
      {
          console.log(geoLoc.province_code);
          window.theme.IsColdPackSbbAllowed = true;
      }else{
        window.theme.IsColdPackSbbAllowed = false;
      }
  
  console.log('after start');
  }

function addColdServiceNoticeToDrawer(){
    var notice = document.querySelector("#rebuy-cart [data-rebuy-custom-code='e0dc3180-529b-4246-8096-3886fb39656c'] #coldnoticebutton") ||
      document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton");
    if(notice) notice.classList.remove("mehidden");
  }

// function addColdServiceNoticeToDrawer(){

//   /*--  coldnoticebutton div is placed in Rebuy SAMRT Cart Widget, only visible based on below code -- */

//   document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton").classList.remove("mehidden");

//   	/*<div id="coldnoticebutton">
// 		<a data-tooltip="Your order contains heat-sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. If you decline cold pack service you accept the risk of heat-damaged products." class="rebuy-button block" title="Your order contains heat sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. " style="background: #d44b3c;border-color: #d44b3c;cursor: pointer;"> Add Cold Pack Service - $3.99</a> 
// 	</div>*/
    	
// }

function removeColdServiceNoticeToDrawer(){
    var notice = document.querySelector("#rebuy-cart [data-rebuy-custom-code='e0dc3180-529b-4246-8096-3886fb39656c'] #coldnoticebutton") ||
      document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton");
    if(notice) notice.classList.add("mehidden");
}

var coldPackAddPending = false;
function addColdPackServiceInCart(forceAdd)
{
                  // Several cart.change scans can overlap after one Add to cart. Allow one add at a time,
                  // and skip it when the live cart already holds a cold pack, so the service is never added twice.
                  if(coldPackAddPending) return false;
                  coldPackAddPending = true;

                  var addData = {
                    'id':window.theme.cart_cold_service_product_vid, 
                    'quantity':1,
                    'properties': {
                           '_Offer': 'FREE'
                     }
                  };

                  fetch((window.routes.cartUrl || '/cart') + '.js', {
                    credentials: 'same-origin',
                    cache: 'no-store',
                    headers: { 'Accept': 'application/json' }
                  }).then(function(response) {
                    if(!response.ok) throw new Error("Cart read failed");
                    return response.json();
                  }).then(function(cart) {
                    var exists = (cart.items || []).some(function(item) { return item.variant_id == window.theme.cart_cold_service_product_vid; });
                    if(exists) return null;
                    return fetch(window.routes.cartAddUrl + '.js', {
                      body: JSON.stringify(addData),
                      credentials: 'same-origin',
                      headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                      },
                      method: 'POST'
                    });
                  }).then(function(response) {
                    if(response === null) return null;
                    if(!response.ok) throw new Error("Cold Pack request failed");
                    return response.json();
                  }).then(function(json) {
                    coldPackAddPending = false;
                    if(json === null) {
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                      return;
                    }
                    setColdPackCookie("coldserviceadded",forceAdd === true ? '0' : '1');
                    /* we have JSON */
                    console.log("---- HEAT SENSITIVE COLD-SERVICE ADDED",json)

                    setColdPackCookie("csautoadd",1);
                      if(forceAdd == true){
                        removeColdServiceNoticeToDrawer();
                        window.theme.cartattributeupdate=true;
                        updateCartAttributeColdPackRemoved("ADDED");
                      }
                    
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  }).catch(function(err) {
                    /* uh oh, we have error. */
                    coldPackAddPending = false;
                    console.error(err)
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  });

  return false;
}

var coldPackScanVersion = 0;
function coldPackCartSignature(items) {
  return JSON.stringify(items.map(function(item) {
    return [item.key || item.variant_id || item.id, item.handle, item.quantity];
  }));
}

function heatSensitiveService(forceAdd)
{
    var scanVersion = ++coldPackScanVersion;
  	removeColdServiceNoticeToDrawer();
    var itmttl = 0;
    var atleastonefound = false;
    var coldpackrequire = false;
    if(window.theme.IsColdPackSbbAllowed == false){
        return;
    }
    var cartItems = window.Rebuy.Cart.getItems().slice();
    var cartSignature = coldPackCartSignature(cartItems);
	cartItems.forEach(function(p, index){
          	var phandle = p.handle;
      		fetch("/products/"+ phandle +".json").then(s=>s.json()).then(function(data){ 
              // Product responses belong only to the unchanged cart that started this scan.
              if(scanVersion !== coldPackScanVersion || cartSignature !== coldPackCartSignature(window.Rebuy.Cart.getItems())) return;
              
              itmttl++;
              if(data.product.tags.includes("Collection_Heat Sensitive"))
              {
                coldpackrequire = true;
                setCookie("coldservicerequired",1);
                var yesExists = window.Rebuy.Cart.getItems().find(s=>s.handle == window.theme.cart_cold_service_product_handle);
                if(yesExists != null){
                  	removeColdServiceNoticeToDrawer();
                  	
                }else if (forceAdd != true && forceAdd != null && getColdPackCookie("coldserviceadded") == "1") {
                  // Customer intensionally removed this cold pack item. So add RED button again.
                  // add div to rebuy drawer.
                  addColdServiceNoticeToDrawer();
                  updateCartAttributeColdPackRemoved("REMOVED");
                  setColdPackCookie("coldserviceadded",0);
                } else {
                    setColdPackCookie("coldserviceadded",0);
                  
                  	// add div to rebuy drawer.
                  	addColdServiceNoticeToDrawer();
                }

                
                if(getColdPackCookie("csautoadd") == "1" && forceAdd != true){
                    return;
                }
                
                var ctotal = window.Rebuy.Cart.subtotal() / 100;
                
                if((forceAdd == true || parseFloat(window.theme.cart_cold_service_amount) <= ctotal)  && (getColdPackCookie("coldserviceadded") != "1")
                   && yesExists == null && atleastonefound == false)
                {
                    atleastonefound = true; // so that Adding cold pack will execute ONE time in Loop of Cart Line items
              		// Yes cart have heat sensitive item, add extra service product. 
                    addColdPackServiceInCart();
                    removeColdServiceNoticeToDrawer();
                }
              }

              if(itmttl == cartItems.length && coldpackrequire == false &&
                 getColdPackCookie("coldserviceadded") == "1") {
                  // COLD SHOT NOT REQUIRED. & PREENT IN CART. SO REMOVE IT.
                  var removeData = { 'id': window.theme.cart_cold_service_product_vid, 'quantity': 0 }; 
                  fetch('/cart/change.js', {
                    body: JSON.stringify(removeData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' 
                    },
                    method: 'POST'
                  }).then(s=>s.json()).then(function(data){
                      window.theme.cartattributeupdate=true;
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                  });
              }
              
            });    
		})
    
    return true;
}

function buttonSubmitNotifyMeKlaviyo(ctrl)
{
  	var pdiv = $(ctrl).closest(".notify-custom");
	var klvkey = "RHdejJ";
  	var cemail = $(pdiv).find("#txtEmail").val();  	
  	var variantid = $(pdiv).attr("data-vid");
  if(cemail == ""){ 
    $("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("Please enter email address.");
    return false;
  }

        fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klvkey, {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            referrer: window.location.origin + "/",
            referrerPolicy: "strict-origin-when-cross-origin",
            headers: {
              "accept": "application/json",
              "accept-language": "en-US,en;q=0.9",
              "content-type": "application/json",
              "priority": "u=1, i",
              "revision": "2024-02-15",
              "sec-fetch-dest": "empty",
              "sec-fetch-mode": "cors",
              "sec-fetch-site": "cross-site",
              "x-klaviyo-onsite": "1"
            },
            body: JSON.stringify({
              data: {
                type: "back-in-stock-subscription",
                attributes: {
                  profile: {
                    data: {
                      type: "profile",
                      attributes: {
                        email: cemail
                      }
                    }
                  },
                  channels: ["EMAIL"]
                },
                relationships: {
                  variant: {
                    data: {
                      type: "catalog-variant",
                      id: "$shopify:::$default:::" + variantid
                    }
                  }
                }
              }
            })
          })
          .then(response => {
            const el = document.querySelector("div.modal[aria-hidden='false'] .modal__inner .responseMsg");
            if (response.status === 200 || response.status === 202) {
              el.innerHTML = "Thanks! You will get a notification when it's back in stock.";
            } else {
              el.innerHTML = "There was something wrong with your request. Please try later.";
            }
          })
          .catch(error => {
            console.error(error);
            const el = document.querySelector("div.modal[aria-hidden='false'] .modal__inner .responseMsg");
            if (el) {
              el.innerHTML = "Alert service down. Sorry for any Inconvenience.";
            }
          });
  
}


function updateCartAttributeColdPackRemoved(parAction)
{
                 var addData = {
                    'attributes': {
                           '_COLDPACK': 'CUSTOMER ' + parAction
                     }
                  };

                  fetch('/cart/update.js', {
                    body: JSON.stringify(addData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' 
                    },
                    method: 'POST'
                  }).then(function(response) {
                    return response.json();
                  }).then(function(json) {
                    /* we have JSON */
                    console.log("---- COLD-SERVICE ATTRIBUTE EXECUTED " + parAction ,json)
                    window.theme.cartattributeupdate=true;
                    
                  }).catch(function(err) {
                    /* uh oh, we have error. */
                    console.error(err)
                    
                  });
    
}
/* CYBER MONDAY RELATED JS */
// function addGiftButton(btntitle){
//   var ne1 = document.createElement("div");
//   ne1.classList.add("myrebuy-freegiftaction");
//   ne1.innerHTML = '<button id="freeItemOfferLink" class="rebuy-button outline" onclick="openGiftCart(this)" type="button">'+ btntitle +' 🎁 </button>';
//   document.querySelector(".rebuy-cart__flyout-integration").before(ne1);
// }
/* END CYBER MONDAY JS*/

/*KLARNA SHOPAY ICONS SETUP SCRIPT */    

  (function(){
  
    var bppayLaterFunction = function(){
    
      var cls = {
        
        settings : {
          productpage_containerdivid: "#payLaterButtons",
          productpage_initialprice : ".product-block-list__item--info .eleSezzelPrice .current_price.price",
          cartpage_totamamt_element: ".rebuy-cart__flyout-subtotal-amount",
          cartpage_containerdiv: ".rebuy-cart__flyout-subtotal", // this will be append below this target
          defaultPreText : "or 4 interest-free payments of ",
          pppricepaylater1 : "#pppricepaylater1",
          carttotalpaylater1 : "#ctppaylater1",
          defaultPriceText : "<b>Sale price $<span id='pppricepaylater1'></span></b>",
          defaultCartTotalText : "<b> $<span id='ctppaylater1'></span></b>",
          defaultImgIconsEndpart : " with <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>',
          defaultCARTDRAWERImgIconsEndpart : " with  <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>'
          
        },
        initProductPage : function(){        	
          	// recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();
           
            
            // bind Variant change event            
            document.addEventListener("variant:changed", function(e){              
              setTimeout(function(){
              		window["bppayLaterFunction"].reBindOnVariantChangeProductpage();
                	window["bppayLaterFunction"].popupInitializations();
              },1000);
            });
            
            
          }
        },
        initCartDrawerPage : function(){     
          
          	// recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.cartpage_containerdiv))
          {
            var d = document.createElement("div");
            d.className = "payLaterButtons";
            d.id = "cartpayLaterButtons";
            
          	d.innerHTML =  this.settings.defaultPreText + this.settings.defaultCartTotalText + this.settings.defaultCARTDRAWERImgIconsEndpart;            
           
            document.querySelector(window.bppayLaterFunction.settings.cartpage_containerdiv).after(d);
            
            var cartemi = this.getCartTotalForEMI();
            if(isNaN(cartemi)){
            	document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
            }else
            {
            	document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
            }
            
          }
        },
        refreshCartHtmls : function(){
          	if(document.querySelector(this.settings.carttotalpaylater1)){
              	var cartemi = this.getCartTotalForEMI();
              	if(isNaN(cartemi)){
              		document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
                }else{
        			document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
                }
            }else{
            	window["bppayLaterFunction"].initCartDrawerPage();
              	window["bppayLaterFunction"].popupInitializations();
              
            }
        },
        reBindOnVariantChangeProductpage:function(){
        
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();           
         }
        },
        getCartTotalForEMI: function(){
        
        	return (parseFloat((parseFloat(document.querySelector(this.settings.cartpage_totamamt_element).innerText.replace("$", "")) * 100) / 4) / 100).toFixed("2");
        },
        getProductPagePriceEMI: function(){
        	var amt = document.querySelector(this.settings.productpage_initialprice).innerText.split("$")[1];
        	return (parseFloat((parseFloat(amt.replace("$", "")) * 100) / 4) / 100).toFixed("2");
        },
        addPopupModalHtmls:function(){
        
          //klarna image url, klarna link
          var htmlStr= '<div class="bpplbody-blackout"></div>';
          // Popup for Afterpay
          htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pafterpay"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i> <a href="https://www.afterpay.com/purchase-payment-agreement" target="_blank" style="display: block;"><img src="https://static.afterpay.com/us-popup-medium.png" srcset="https://static.afterpay.com/us-popup-medium.png 1x, https://static.afterpay.com/us-popup-medium@2x.png 2x" style="max-width: 700px; display: block; width: 100%;" alt="Afterpay"></a>  </div>';
          
          // Popup for Klarna
          //htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pklarna"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i><a href="https://www.klarna.com/us/business/products/installments" target="_blank" style="display: block;"><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/klarna-popup-img.png?v=1619243795"  style="max-width: 650px; display: block; width: 100%;" alt="Klarna"></a></div>'
          
          
          //add html into end of body
          var d = document.createElement("div");
          d.innerHTML = htmlStr;
          document.body.appendChild(d);
          
        },
        popupInitializations: function() {
  const modalTriggers = document.querySelectorAll('.popup-trigger');
  const bodyBlackout = document.querySelector('.bpplbody-blackout');

  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const { popupTrigger } = trigger.dataset;
      const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`);

      // Store the element that triggered the modal
      const triggerElement = trigger;

      // Open the modal and focus on it
      popupModal.classList.add('is--visible');
      bodyBlackout.classList.add('is-blacked-out');
      setTimeout(() => {
        popupModal.querySelector('.bpplpopup-modal__close').focus(); // Focus on the close button
      }, 100);

      // Close the modal when the close button is clicked
      popupModal.querySelector('.bpplpopup-modal__close').addEventListener('click', () => {
        closeModal(popupModal, triggerElement);
      });

      // Close the modal when the alternative close button is clicked (if exists)
      if (popupModal.querySelector('.bpplpopup-modal__closebtn') !== null) {
        popupModal.querySelector('.bpplpopup-modal__closebtn').addEventListener('click', () => {
          closeModal(popupModal, triggerElement);
        });
      }

      // Close the modal when the blackout area is clicked
      bodyBlackout.addEventListener('click', () => {
        closeModal(popupModal, triggerElement);
      });

      // Close modal when the Escape key is pressed
      document.addEventListener('keydown', function escapeHandler(event) {
        if (event.key === 'Escape') {
          closeModal(popupModal, triggerElement);
          document.removeEventListener('keydown', escapeHandler); // Remove the event listener after closing modal
        }
      });

      // Function to close the modal and reset focus
      function closeModal(popupModal, triggerElement) {
        popupModal.classList.remove('is--visible');
        bodyBlackout.classList.remove('is-blacked-out');

        // Return focus to the trigger element after a small delay
        setTimeout(() => {
          triggerElement.focus(); // Redirect focus back to the element that opened the modal
        }, 200); // Short delay to ensure modal closes properly
      }
    });
  });
         } 
      }
     
      window["bppayLaterFunction"] = cls;
      
   		if(theme.pageType == "product"){
      		cls.initProductPage();
  		}
      cls.initCartDrawerPage();
      cls.addPopupModalHtmls();
  	  cls.popupInitializations();
      
    };
    
    
    bppayLaterFunction();
    
    
  })();
  
  function shopapayclick(){
    if(document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('#shopify-installments-cta') != null)
        document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('#shopify-installments-cta').click();
    else if(document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('#shopify-installments-cta'))
        document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('shop-pay-installments-banner').shadowRoot.querySelector('#shopify-installments-cta').click();
  }

/*  KLARNA SHOP PAY AFTER PAY SCRIPT END  */

/*--- COUNTRY BASD ON IP IDENTIFICATIO ---*/    
window.visitorCountryKey = "mycountrypro";
window.visitorStateProvinceKey = "mystatepro";
window.iplookdomain = "https://geoip.sezzle.com/v1/geoip/ipdetails";

function addCountryTag(countryCode){
    document.body.classList.add("cusCntCode" + countryCode);
}
function addDynamicCssForCountryRestriction(){
  	// body tag with cusCntCodeSG with product's metafields, on section  [data-section-type="product"] .   
  	var curVisitorCountry = localStorage.getItem(window.visitorCountryKey);
  	//debugger
  if(document.querySelector("section[data-section-type='product']") != null){
  	document.querySelector("section[data-section-type='product']").classList.forEach(function(d){ 
    	// matches the SAME country, Restirction on section & The visitor's current country. Then append the CSS to hide product ATC button.
      	if(d == "block" + curVisitorCountry){
          	var targetEle = 'body.cusCntCode'+ curVisitorCountry +' section.block'+ curVisitorCountry +' .product-form__payment-container';
      		//var css = 'body.cusCntCode'+ curVisitorCountry +' section.'+ d +' .product-form__payment-container [type="submit"]{display: none;}  section .rebuy-bundle__actions {visibility: hidden;}';
          	var css = 'body.cusCntCode'+curVisitorCountry+' .block'+ curVisitorCountry +' [type="submit"], body.cusCntCode'+curVisitorCountry+' .block'+curVisitorCountry+' [data-action="open-modal"] {visibility:hidden} section .rebuy-bundle__actions {visibility: hidden;}';
          	var s = document.createElement("style");
          	s.innerText = css;
          	document.body.append(s);
          
  			if(document.querySelector(targetEle) != null)
          		document.querySelector(targetEle).innerHTML = "<b>We can not ship this product to the "+ curVisitorCountry +". </b>"
      	}	                                                                                                
    });  
  }else{
  		// For collection page
    		var targetEle = 'body.cusCntCode'+ curVisitorCountry +' section.block'+ curVisitorCountry +' .product-form__payment-container';
      		//var css = 'body.cusCntCode'+ curVisitorCountry +' section.'+ d +' .product-form__payment-container [type="submit"]{display: none;}  section .rebuy-bundle__actions {visibility: hidden;}';
          	var css = 'body.cusCntCode'+curVisitorCountry+' .block'+ curVisitorCountry +' [type="submit"], body.cusCntCode'+curVisitorCountry+' .block'+curVisitorCountry+' [data-action="open-modal"] {visibility:hidden} section .rebuy-bundle__actions {visibility: hidden;}';
          	var s = document.createElement("style");
          	s.innerText = css;
          	document.body.append(s);
  }	
}

function PrintOrderDiv() 
{  
       var divContents = document.getElementById("printmyorder").innerHTML;  
       var printWindow = window.open(window.location.href,'','height=500,width=600');  
       printWindow.document.write('<html><head><title>Order Print</title><style>body {font-family: "DIN Next", "Roboto", sans-serif;}</style>');  
       printWindow.document.write('</head><body >');  
       printWindow.document.write(divContents);  
       printWindow.document.write('</body></html>');  
       printWindow.document.close();  
       printWindow.print();  
       //printWindow.close();  
}

function setPageNumbersMobileGallery() {
  
  const galleryImages = document.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered) .product-gallery__image')
  const visibleImg = document.querySelector("#imgmyModalZoomer01");
  let TotalImgCount = galleryImages.length;
  let CurrentImgIndex = -1;
  galleryImages.forEach(function(item, index) {
       if (visibleImg.src.includes(item.attributes["data-zoom"].value)) {
           // Set the current image index
          CurrentImgIndex = index;           
       }
  });

  document.querySelector('.mygal_pagination-current').innerText = (CurrentImgIndex + 1);
  document.querySelector('.mygal_pagination-count').innerText = TotalImgCount;
  
}

function initMobileGalleryZoomer() {

      
    // Get the modal
    const modal = document.getElementById('myModalZoomer');
    const modalImg = document.getElementById("imgmyModalZoomer01");
    
    var img = document.querySelectorAll('.product-gallery__image');
    for (var i=0; i<img.length; i++){
    img[i].onclick = function(){         
            modal.style.display = "flex";
            modalImg.src = this.attributes["data-zoom"].value;
            modalImg.alt = this.alt;     
            setPageNumbersMobileGallery();
        }
    }
    // When the user clicks on <span> (x), close the modal
   
    document.getElementById("btnClosemyModal").onclick = function() {
        modalImg.className += " out";
        setTimeout(function() {
            modal.style.display = "none";
            modalImg.className = "myModalZoomerCls-content";
        }, 400);
    }

    // Get all the elements with class "mygal__button"
    let buttonsPrevNext = document.querySelectorAll(".mygal__button");
    
    // Iterate over the buttons and bind a click event to each of them
    buttonsPrevNext.forEach(button => {
        button.addEventListener('click', function(event) {
            // Handle the click event here
            const galleryImages = document.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered) .product-gallery__image');
            const visibleImg = document.querySelector("#imgmyModalZoomer01");
            let newupdatedUrl = null;
            const btnClicked = this;
            galleryImages.forEach(function(item, index) {
                if (visibleImg.src.includes(item.attributes["data-zoom"].value)) {

                    if (btnClicked.attributes["aria-label"].value == "Next") {
                        // Check if there's a next item
                        const nextItem = galleryImages[index + 1];            
                        if (nextItem && newupdatedUrl == null) {
                            newupdatedUrl = nextItem.attributes["data-zoom"].value;
                        } else if (newupdatedUrl == null){
                            // If next item doesn't exist, print the first item
                            newupdatedUrl = galleryImages[0].attributes["data-zoom"].value;
                        }
                    }else{
                      // Check if there's a next item
                        const prevItem = galleryImages[index - 1];            
                        if (prevItem && newupdatedUrl == null) {
                            newupdatedUrl = prevItem.attributes["data-zoom"].value;
                        } else if (newupdatedUrl == null){
                            // If next item doesn't exist, print the first item
                            newupdatedUrl = galleryImages[galleryImages.length - 1].attributes["data-zoom"].value;
                        }
                    }
                  
                }
            });
            if(newupdatedUrl != null){
              visibleImg.src = newupdatedUrl;
              setPageNumbersMobileGallery();
            }
          
        });
    });
}



(function(){
  
    // check for products & their tags, if california related cookie exists then display warning.
    if(theme.pageType == "index"){
    	localStorage.removeItem(window.visitorCountryKey);
    }

    if(theme.pageType == "product" && (window.matchMedia('(max-width: 640px)').matches)){
        initMobileGalleryZoomer();
    }
  
    if(localStorage.getItem(window.visitorCountryKey) == undefined){
      
      	fetch(window.iplookdomain)
        .then(response => response.json())
        .then(data => { 
              
              	let json = data;
             	if(json.country_iso_code && json.city){
                  	localStorage.setItem(window.visitorCountryKey,json.country_iso_code);
                  	addCountryTag(json.country_iso_code);
                  
                    if(json.city.toLowerCase() == "california" || json.region_name.toLowerCase() == "california"){
                        localStorage.setItem(window.visitorStateProvinceKey,"california");                    	
                    }else{
                    	localStorage.setItem(window.visitorStateProvinceKey,json.region_name.toLowerCase());                      	
                	}
                  
                  if(theme.pageType == "product" || theme.pageType == "collection"){
                      addDynamicCssForCountryRestriction();
                  }
                  
            	}
    		}
            );
        }else{
        	addCountryTag(localStorage.getItem(window.visitorCountryKey));
          	if(theme.pageType == "product" || theme.pageType == "collection"){
            	addDynamicCssForCountryRestriction();
            }
        }
    
 })();
/*-- END COUNTRY IDENTIFICATION BASED ON IP --*/
function checkScreenSize() {
        // find elements
        let elem = document.querySelector('footer a#netaa');
        let footerList = document.querySelector('.footer__block-list');

        if(window.matchMedia('(max-width: 640px)').matches) {
            // if the width of browser window is less than or equal to 640px
            if(elem && footerList) {
                // append element to end of the list
                footerList.appendChild(elem);
            }
        }
    }

    // Run once at load
    checkScreenSize();


/* ===== MANUAL CONDITIONAL FREE GIFT IN REBUY SMARTCART (Multivitamins) =====
   Shows a manual "Add Free Gift" button in SmartCart only when the cart holds a
   product from the Multivitamins collection (tag-driven). Clicking adds the gift
   variant; if the qualifying product is later removed, the gift is auto-removed.
   The gift is zeroed at checkout by a separate Shopify automatic discount.
   Mirrors this store's cold-pack pattern: /products/{handle}.json tag lookup,
   window.routes cart URLs, and a `cart:refresh` dispatch after cart mutations. */
var GIFT = {
    variantId: 44910845132982,                 // (1) gift variant ID
    tags: [                                    // (2) collection tags, LOWER-CASE
        'collection_multi-vitamins',
        'multivitamins',
        'vitamin pack',
        'collection_bariatric multivitamins',
        'collection_multivitamins',
        'product type_multivitamins'
    ],
    container: 'e0dc3180-529b-4246-8096-3886fb39656c', // (3) data-rebuy-custom-code GUID (shared with cold-pack)
    marker: '_GiftMintInsert',                 // (4) unique cart property (avoids _Offer / _OfferItem / _COLDPACK)
    label: 'Add Free ScentCerts Mint 🎁'       // (5) button label
};
var GIFT_REFRESH_EVENT = 'cart:refresh';       // this store's cart-refresh event (cold-pack uses the same)
var giftTagCache = {}, giftBusy = false;

function giftUrl(which) {
    var r = window.routes || {};
    return (which === 'add' ? (r.cartAddUrl || '/cart/add') : (r.cartChangeUrl || '/cart/change')) + '.js';
}
function giftTagsMatch(raw) {
    var list = (Array.isArray(raw) ? raw : String(raw || '').split(',')).map(function (t) { return String(t).trim().toLowerCase(); });
    return GIFT.tags.some(function (t) { return list.indexOf(t) > -1; });
}
function giftItemEligible(handle, cb) {
    if (!handle) { return cb(false); }
    if (giftTagCache.hasOwnProperty(handle)) { return cb(giftTagCache[handle]); }
    fetch('/products/' + handle + '.json').then(function (r) { return r.json(); })
        .then(function (d) { var m = d && d.product ? giftTagsMatch(d.product.tags) : false; giftTagCache[handle] = m; cb(m); })
        .catch(function () { cb(false); });
}
function giftIsGiftLine(it) {
    // Match the gift line by variant id OR by the marker property we set on add,
    // so detection is robust to however Rebuy shapes the line item id.
    return it.variant_id == GIFT.variantId || it.id == GIFT.variantId
        || (it.properties && it.properties[GIFT.marker]);
}
function giftCartEligible(items, cb) {
    if (!items || !items.length) { return cb(false); }
    var pending = items.length, found = false;
    items.forEach(function (it) {
        if (giftIsGiftLine(it)) { if (--pending === 0) cb(found); return; }
        giftItemEligible(it.handle, function (m) { if (m) found = true; if (--pending === 0) cb(found); });
    });
}
function giftInCart(items) { return (items || []).some(giftIsGiftLine); }

function giftRenderButton() {
    var box = document.querySelector("#rebuy-cart [data-rebuy-custom-code='" + GIFT.container + "']")
        || document.querySelector('#rebuy-cart .rebuy-cart__flyout-footer');
    if (!box || document.getElementById('conditionalGiftBtn')) return;
    var b = document.createElement('button');
    b.id = 'conditionalGiftBtn'; b.type = 'button'; b.className = 'rebuy-button outline';
    b.textContent = GIFT.label; b.addEventListener('click', giftAdd);
    box.insertBefore(b, box.firstChild);
}
function giftRemoveButton() { var b = document.getElementById('conditionalGiftBtn'); if (b) b.remove(); }

function giftVisibility(cartObj) {
    // Prefer the fresh cart carried by the Rebuy event; Rebuy.Cart.getItems() can
    // still be stale right after a line is removed, which leaves the gift stuck in cart.
    var items;
    if (cartObj && cartObj.items) { items = cartObj.items; }
    else if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.getItems === 'function') { items = window.Rebuy.Cart.getItems() || []; }
    else { return; }
    var inCart = giftInCart(items);
    giftCartEligible(items, function (eligible) {
        if (eligible && !inCart) { giftRenderButton(); }
        else if (!eligible && inCart) { giftRemoveButton(); giftRemove(); }
        else { giftRemoveButton(); }
    });
}
function giftAdd() {
    if (giftBusy) return; giftBusy = true;
    var b = document.getElementById('conditionalGiftBtn'); if (b) { b.disabled = true; b.textContent = 'Adding...'; }
    // id must be a String: /cart/change.js validates it as a string and rejects a JSON number.
    var body = { id: String(GIFT.variantId), quantity: 1, properties: {} }; body.properties[GIFT.marker] = 'FREE GIFT';
    fetch(giftUrl('add'), {
        body: JSON.stringify(body), credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' }, method: 'POST'
    }).then(function (r) { return r.json(); })
        .then(function () { giftRemoveButton(); document.documentElement.dispatchEvent(new CustomEvent(GIFT_REFRESH_EVENT, { bubbles: true })); })
        .catch(function (e) { console.error(e); if (b) { b.disabled = false; b.textContent = GIFT.label; } })
        .then(function () { giftBusy = false; });
}
function giftRemove() {
    if (giftBusy) return; giftBusy = true;
    fetch(giftUrl('change'), {
        body: JSON.stringify({ id: String(GIFT.variantId), quantity: 0 }), credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'xmlhttprequest' }, method: 'POST'
    }).then(function (r) { return r.json(); })
        .then(function () { document.documentElement.dispatchEvent(new CustomEvent(GIFT_REFRESH_EVENT, { bubbles: true })); })
        .catch(function (e) { console.error(e); })
        .then(function () { giftBusy = false; });
}

function giftEventCart(event, key) { return event && event.detail && event.detail[key] ? event.detail[key].cart : null; }
document.addEventListener('rebuy:smartcart.show', function (e) { giftVisibility(giftEventCart(e, 'smartcart')); });
document.addEventListener('rebuy:smartcart.ready', function (e) { giftVisibility(giftEventCart(e, 'smartcart')); });
document.addEventListener('rebuy:cart.change', function (e) {
    setTimeout(function () { giftVisibility(giftEventCart(e, 'cart')); }, 500);
});
